module.exports = __webpack_public_path__ + "img/ieshop_single_logo.8aa99938.png";